import { userActions } from './user-slice';
import { getData, patchData } from '../common-actions';
import { fetchUsers, patchSkillLevels, patchLanguageLevels, searchUsers } from '../../lib/api';

export const getUsers = (token, signal) => {

  return getData({
    token: token,
    actions: userActions,
    fetchFn: (token) => fetchUsers(token, signal),
    dataKey: "users",
    name: "get users",
    setFunctionName: "setUsers"
  });
};

export const searchForUsers = (token, searchCriteria, signal) => {
  console.log("user-actions - searchForUsers");
  console.log(searchCriteria);
  return getData({
    token: token,
    actions: userActions,
    fetchFn: (token) => searchUsers(token, searchCriteria, signal),
    dataKey: "users",
    name: "search users",
    setFunctionName: "setUsers"
  });
}

export const patchUpdateSkillLevels = (token, skillLevels) => {

  return patchData({
    token: token,
    actions: userActions,
    patchFn: patchSkillLevels,
    dataKey: "skillLevels",
    name: "patch skill levels",
    setFunctionName: "patchSkillLevels",
    patchData: skillLevels,
    successMessage: "Skill levels saved successfully",
  });
};

export const patchUpdateLanguageLevels = (token, skillLevels) => {
  return patchData({
    token: token,
    actions: userActions,
    patchFn: patchLanguageLevels,
    dataKey: "skillLevels",
    name: "patch language levels",
    setFunctionName: "patchLanguageLevels",
    patchData: skillLevels,
    successMessage: "Language levels saved successfully",
  });
};
